<div class="formRow">
  <mat-form-field>
    <mat-label>BSB Number</mat-label>
    <input
      matInput
      [formControl]="formControl"
      (paste)="onPaste($event)"
      (input)="searchBSB()"
      placeholder="{{ placeholder }}"
      type="text"
      appNumericOnly
      pattern="[0-9]*"
      maxlength="6"
    />
    <mat-error *ngIf="formControl.hasError('invalidBSB') || formControl.hasError('minlength')">
      Please Enter a valid BSB Number.
    </mat-error>
    <mat-error *ngIf="formControl.hasError('required') && formControl.touched">
      BSB number is required.
    </mat-error>
    <mat-hint>
      <ng-container *ngIf="showSpinner; else showBankDetails">
        <mat-spinner color="primary" diameter="16"></mat-spinner>
      </ng-container>
      <ng-template #showBankDetails>
        <ng-container *ngIf="bankDetails">
        Bank - {{ bankDetails.message.bankname }}</ng-container>
      </ng-template>
    </mat-hint>
  </mat-form-field>
</div>
